import Search from "ui/search";
import CameraWithPresetItem from "./camera-with-preset-item";
import { Skeleton } from "antd";

export default function CameraList({
  cameras,
  selectedCamera,
  loading,
  onPresetClick,
  onSelectedCamera,
  currentPreset,
}) {
  return (
    <div className="w-full">
      <div className="mb-3">
        <Search placeholder="Search camera name..." />
      </div>
      {loading && <Skeleton className="mt-4" />}
      {!loading &&
        cameras.map((data: any) => {
          return (
            <CameraWithPresetItem
              camera={data}
              cameraSelected={selectedCamera?.id === data.id}
              onPresetClick={(preset) => {
                onPresetClick(preset);
                onSelectedCamera(data);
              }}
              currentPreset={currentPreset}
            />
          );
        })}
    </div>
  );
}
